const axios = require('axios');

export function getCustomerInfo(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.APP_URL + 'api/get_customer.php?id='+id)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        reject(error);
      })
  })

}

export function updateCustomerInfo(data) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.APP_URL + 'api/update.php', JSON.stringify(data))
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        reject(error);
      })
  })
}

export function priceComparisonReport(data) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.APP_URL + 'api/search_naver_report.php', JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function(response) {
        console.log(response)
        resolve(data);
      })
      .catch(function(error) {
        reject(error);
      })
  })
}
export function priceComparisonReportEmail(data) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.APP_URL + 'api/search_naver_report.php', JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function(response) {
        console.log(response)
        resolve(data);
      })
      .catch(function(error) {
        reject(error);
      })
  })
}

export function getPublicSender() {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.APP_URL + 'api/get_public_sender.php')
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        reject(error);
      })
  })

}



// WEBPACK FOOTER //
// ./src/api/customer.js